/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AllSiteSettings } from './AllSiteSettings';
const InternalAboutParser = /* #__PURE__ */ parsers.object([
    ['settings', AllSiteSettings],
]);
export class InternalAbout extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return InternalAboutParser.decode(input).map(res => new InternalAbout(res));
    }
    static unsafeDecode(input) {
        return InternalAbout.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InternalAboutParser.encode(data);
    }
    static schema() {
        return InternalAboutParser.schema();
    }
}
